import { Transition } from '@unseenco/taxi'
import { gsap } from 'gsap'
import App from '@scripts/app'

export default class TransitionManager extends Transition {
  /**
   * Loads the destination page's assets.
   * Then starts its IN transition.
   *
   * @param {Object} params - An object containing transition parameters.
   * @param {Element} params.to - The destination page element.
   * @param {Object} params.trigger - The trigger of the page change.
   * @param {Function} params.done - This function is called when the transition is over.
   *
   * @private Called by `Highway`.
   * @returns {void}
   */
  onEnter({ to, trigger, done }) {
    gsap.set(to.$page.elemAppear, { alpha: 0 })

    to.$page.load()
      .then(to.$page.prepare())
      .then(() => {
        to.$page.prepareInit()
        // Force destroy in case it has not been done during transition.
        if (this.from && !this.from.$page.destroyed) this.from.$page.destroy()
        // Force remove in case it has not been done during transition.
        if (this.from && this.from.parentElement) this.from.remove()

        this.from = null

        const tl = gsap.timeline({
          delay: 0.25,
          onComplete: done
        })

        // tl.fromTo(to.$page.elemAppear, { alpha: 0 }, {
        //   duration: 1, alpha: 1, ease: 'quad.out'
        // })
        tl.set(to.$page.elemAppear, { alpha: 1 })
        tl.add(to.$page.appear())
      })
  }

  /**
   * Starts the source page's OUT transition.
   *
   * @param {Object} params - An object containing transition parameters.
   * @param {Element} params.from - The source page element.
   * @param {Object} params.trigger - The trigger of the page change.
   * @param {Function} params.done - This function is called when the transition is over.
   *
   * @private Called by `Highway`.
   * @returns {void}
   */
  onLeave({ from, trigger, done }) {
    this.from = from

    const tl = gsap.timeline({
      onComplete: () => {
        App.domScroll.scrollTo(0, 0)
        App.scrollY = 0
        App.S.scroll = 0
        App.S.targetScroll = 0
        App.S.contentNode.scrollTop = 0
        App.domScroll.scrollTop = 0
        App.domWrapper.scrollTop = 0
        App.S.scrollTo(0, { immediate: true })
        from.classList.add('!absolute', '!top-0')
        done()
      }
    })

    tl.fromTo(this.from.$page.elemAppear, { alpha: 1 }, {
      duration: 0.5, alpha: 0, ease: 'quad.out'
    })
  }
}
